import ParameterErrors from '../../errors/ParameterErrors';
import ReasonsHelper from './ReasonsHelper';
const { throwNotProvided } = ParameterErrors;
const OBJECT_ID_JSON_KEY='o';
const REASONS_JSON_KEY='r';
export default class QuadrantReason {
	constructor({objectId, reasons}){
		this._objectId = objectId; 
		this._reasons = reasons;
	}
	get objectId(){
		return this._objectId;
	}
	get reasons(){
		return this._reasons;
	}
	get description(){
		if(!this._reasons)
			return '';
		let str='';
		let first= true;
		this._reasons.forEach(reason=>{
			if(first)
				first = false;
			else str+=',';
			str+=this._objectId;
			str+=':';
			str+=ReasonsHelper.getDescription(reason);
		});
		return str;
	}
	static fromJSON(jObject){
		const objectId = jObject[OBJECT_ID_JSON_KEY];
		const reasons = jObject[REASONS_JSON_KEY];
		return new QuadrantReason({objectId, reasons});
	}
}